<template>
    <custom-container-full :budget-data="budgetLine">
        <div class="main-injerto-select">
            <div v-show="!noPrice">
                <h4 class="c-question c-question-first">Selecciona el pie del injerto</h4>
                <p>
                    También puedes escoger Babyplant Selección y nos encargaremos de indicar el pie que mejor se adapte a tu variedad.
                </p>
                <injerto-select-input v-model="varietyId" :budget-line-date="budgetLineDate"
                                      @variety-data-changed="varietyDataChanged"
                                      @other-date="otherDate" @date-selected="dateSelected"
                                      @date-problem="dateProblemChanged" :dateChanged.sync="dateChanged"
                                      :main-variety-id="mainVarietyId" :filters="filters" :no-price-message.sync="noPrice"
                                      :block-to-date="blockToDate" :date="date"
                ></injerto-select-input>
            </div>
            <div v-show="noPrice" class="c-variety-no-price">
                <no-price @choose-other-variety="noPrice = false"></no-price>
            </div>
        </div>
        <template v-slot:columnExtraData>
            <btn-next :disabled-next="disabledNext" @click="goNext" :url-back="route('custom.variety-select')"></btn-next>
        </template>
    </custom-container-full>
</template>

<script>
    import CustomContainerFull from "./CustomContainerFull";
    import BtnNext from "./BtnNext";
    import ChangeDateVariety from "./ChangeDateVariety";
    import ChangedDateVariety from "./ChangedDateVariety";
    import InjertoSelectInput from "./InjertoSelectInput";
    import NoPrice from "./NoPrice";

    export default {
        name: "InjertoSelect",
        components: {
            NoPrice,
            InjertoSelectInput,
            ChangedDateVariety,
            ChangeDateVariety,
            CustomContainerFull,
            BtnNext,
        },
        props: {
            budgetData: {
                type: Object
            }
        },
        data() {
            return {
                varietyId: null,
                varietyData: null,
                saving: false,
                savingNewDate: false,
                budgetLine: null,
                dateProblem: false,
                dateChanged: null,
                noPrice: false
            }
        },
        computed: {
            disabledNext() {
                return !this.varietyId || this.dateProblem;
            },
            budgetLineDate() {
                return moment(this.budgetLine.date).toDate();
            },
            mainVarietyId() {
                return this.budgetLine.variety_id;
            },
            filters() {
                return this.budgetLine.filters;
            }
        },
        watch: {
            budgetData: {
                deep: true,
                handler() {
                    this.budgetDataChanged();
                }
            }
        },
        methods: {
            goNext() {
                let vm = this;
                vm.saving = true;
                let formData = new FormData();
                formData.append('variety_pie_id', vm.varietyId);
                axios.post(vm.route('custom.injerto-select-next'), formData).then((response) => {
                    window.location = vm.route('custom.quantity-select');
                }).catch(e => {
                    Vue.toasted.error("Error al enviar los datos al servidor", {
                        duration: 3000
                    });
                }).finally(() => {
                    vm.saving = false;
                });
            },
            saveNewDate(date) {
                let vm = this;
                vm.savingNewDate = true;
                let formData = new FormData();
                formData.append('change_date', 1);
                formData.append('date', moment(date).format('YYYY-MM-DD'));
                axios.post(vm.route('custom.injerto-select-next'), formData).then((response) => {
                    vm.dateChangedServer(date);
                }).catch(e => {
                    Vue.toasted.error("Error al enviar los datos al servidor", {
                        duration: 3000
                    });
                }).finally(() => {
                    vm.savingNewDate = false;
                });
            },
            varietyDataChanged(varietyData) {
                this.varietyData = varietyData
            },
            dateSelected(date) {
                this.saveNewDate(date);
            },
            otherDate() {
                this.goNext();
            },
            dateChangedServer(date) {
                this.dateChanged = date;
                this.budgetLine.date = moment(date).format('YYYY-MM-DD');
            },
            budgetDataChanged() {
                this.budgetLine = this.budgetData;
                this.varietyId = this.budgetLine.variety_pie_id;
            },
            dateProblemChanged(value) {
                this.dateProblem = value;
            },
            blockToDate() {
                return moment(this.budgetLine.block_to_date).toDate();
            },
            date() {
                return this.budgetLine.date;
            }
        },
        created() {
            this.budgetDataChanged();
        }
    }
</script>

<style scoped>

    .main-injerto-select {
        max-width: 450px;
        margin: auto;
    }

    .c-question-first {
        font-weight: bold;
        padding-top: 1.2em;
    }

    .c-variety-no-price {
        padding-top: 1.2em;
    }

    @media (min-width: 992px) {
        .main-injerto-select {
            padding-bottom: 1rem;
        }
    }

</style>
